import styled, { css } from "styled-components";

export const SharedImageStyles = css`
  border-radius: 0.25rem;
  max-height: 100%;
  max-width: 100%;
`;

export const Image = styled.img`
  ${SharedImageStyles}
  object-fit: cover;
`;

export const PDFImage = styled.iframe`
  ${SharedImageStyles}
  object-fit: fill;
`;
